import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MaintenanceStateService } from './maintenance-state.service';

/**
 * Catches 503 maintenance responses from any API call and activates the
 * maintenance screen via MaintenanceStateService.  This ensures that users
 * who already have the app open when maintenance starts are blocked
 * immediately on their next API interaction, without needing a page reload.
 *
 * The error is still re-thrown so per-call error handlers can run, but the
 * maintenance screen overlay (driven by blockingMaintenanceActive) will
 * replace the router outlet, effectively blocking further interaction.
 */
export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceState = inject(MaintenanceStateService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && maintenanceState.isMaintenanceError(error)) {
        const body = error.error as { until?: unknown };
        const normalizedError =
          body?.until === null
            ? new HttpErrorResponse({
                error: { ...body, until: undefined },
                headers: error.headers,
                status: error.status,
                statusText: error.statusText,
                url: error.url ?? undefined,
              })
            : error;

        maintenanceState.applyFromError(normalizedError);
      }
      return throwError(() => error);
    }),
  );
};
